export enum CurrencyActions {
  RequestForCurrency = 'Request data for currency',
  RequestForCurrencyIsAccepted = 'Data for currency is accepted',
  RequestForCurrencyIsRejected = 'Data for currency is rejected',
}
